module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/component/specialitymaster/specialitymaster.component.css
// module id = ./src/app/component/specialitymaster/specialitymaster.component.css
// module chunks = main